<vhv-modal-area>
    <ng-container area>

        <!-- HIer die Baugeraete-spezifischen Panels einfügen. Logik ist  gleich, wie bei der Modal Area im Common -->

    </ng-container>
</vhv-modal-area>
